export const queryKeys = {
  GET_REMAINING_HOUSES: 'GET_REMAINING_HOUSES'
};
